export const CLOUDINARY_CONFIG = {
  cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'dg8t8o99o',
  uploadPreset:
    process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'neev_unsigned',
  uploadUrl: `https://api.cloudinary.com/v1_1/${
    process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'dg8t8o99o'
  }/image/upload`,
};

export const ADMIN_PASSWORD =
   'Neev$$1234';
